// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.


// ========================
// = Stimulus Controllers =
// ========================

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

const application = Application.start()
const context = require.context("src/controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))
